import { isSgInternalNetwork, setNavigateAsCookie } from "@dx/portal/user";
import { debug } from "@dx/portal/utils";
import ServerErrorPage from "error/ServerErrorPage";
import { createRoot } from "react-dom/client";
import App from "./App";

const domRoot = document.getElementById("developer-root");

if (!domRoot) {
  throw Error('expected <div id="developer-root" /> in document');
}

debug("app-shell bootstrap");
debug(`document.location: ${document.location.pathname}`);

setNavigateAsCookie(undefined);

if (
  document.location.pathname !== process.env.REACT_APP_SG_CONNECT_REDIRECT_URI!
) {
  debug("check network");
  isSgInternalNetwork()
    .then((isSgInternalNetwork) => {
      debug({ isSgInternalNetwork });
      createRoot(domRoot).render(<App isSgInternal={isSgInternalNetwork} />);
    })
    .catch(() => {
      createRoot(domRoot).render(<ServerErrorPage />);
    });
}
